import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { API_URL } from '../config';
import Popular from './Popular';
import Comments from './Comments';




const Deshsingle = () => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}api/districtsnews/${id}`);
        if (response.data.status === 'success') {
          setItem(response.data.data);
        } else {
          setError('डेटा नहीं मिला');
        }
      } catch (err) {
        console.error(err);
        setError(`डेटा लाने में विफल: ${err.message || 'Unknown error'}`);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const renderLoading = () => (
    <div className="preloader-container">
      <div className="preloader">
        <div className="preloader__text">खबर लोड हो रहा है...</div>
      </div>
      <style jsx>{`
        .preloader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          background: #ebeef0;
          color: #015d72;
          font: 1.5em 'Dosis', sans-serif;
        }
        .preloader {
          animation: fadeIn 1s infinite;
        }
        .preloader__text {
          opacity: 1;
          animation: fade 2s infinite;
        }
        @keyframes fade {
          0% {
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.5;
          }
        }
        @keyframes fadeIn {
          0% {
            transform: scale(0.8);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );

  if (loading) return renderLoading();
  if (error) return <div>{error}</div>;

  const { DistictName, link, image, short_description, description } = item;

  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-8">
            <h1 className="mb-4">{DistictName}</h1>
            <div className="position-relative rounded overflow-hidden mb-3">
              {link ? (
                <iframe
                  src={link}
                  title={DistictName}
                  className="img-fluid rounded w-100"
                  style={{ height: '400px' }}
                  allowFullScreen
                />
              ) : (
                <img
                  src={`${API_URL}${image}`}
                  className="img-fluid rounded w-100"
                  alt={DistictName}
                />
              )}
            </div>
            <h4 className="mt-4">{short_description}</h4>
            <p>{description}</p>

            <Comments />
          </div>
          <Popular />
        </div>
      </div>
    </div>
  );
};

export default Deshsingle;
